import {CallJs} from "../../lib/types";
import {CommandCaller} from "../../lib/commands";
import * as React from "react"
import * as ReactDOM from "react-dom"
import {Button} from "../../lib/sbhtml/button";
import {Alignment, Data, FixedDataGrid, Row} from "../../lib/sbhtml/fixed-data-grid";
import {centeredModalProps, Modal} from "../../lib/sbhtml/modal";
import {Form} from "../../lib/sbhtml/form";
import {Item} from "../../lib/sbhtml/field";
import {Input} from "../../lib/sbhtml/input";
import {Textarea} from "../../lib/sbhtml/textarea";
import {SingleBox} from "../../lib/sbhtml/select";
import {Radio} from "../../lib/sbhtml/radio";
import {dateToYYYYMMDD} from "../../lib/utils";
import {monthToUserString, numberToMaybeMonth} from "../../lib/date-utils";
import {DatePicker} from "../../lib/sbhtml/datePicker";
import {Checkbox} from "../../lib/sbhtml/checkbox";
import NumberFormatOptions = Intl.NumberFormatOptions;

enum FilterType {
	MultiSelect = 1,
	DateRange = 2,
	YesNo = 3,
	Select = 4
}

type ReportFilterDateRangeType =  "monthYearRange"|"dateRange"|"thisYear"|"yesterday"|"thisMonth"|"lastYear"|"lastMonth"|"today"

type ReportFilterIdType = (number|string) & {____impossible_and_doesnt_exist: ReportFilterIdType}

type ReportFilterDateRange = {
	filterType: FilterType.DateRange
	selectedFilterItems: [undefined|{fromDate: string, id:ReportFilterDateRangeType, label: string, toDate: string}]
}

type ReportFilterYesno = {
	filterType: FilterType.YesNo
	selectedFilterItems: [undefined|{selected: boolean}]
}

type ReportFilterMultiSelectType = {
	filterType: FilterType.MultiSelect
	filterItems: {childName: string, childValue: string}[],
	selectedFilterItems: {id: string, label: string}[]
}

type ReportFilterSelectType = {
	filterType: FilterType.Select
	filterItems: {id: string, label: string}[],
	selectedFilterItems: {id: string, label: string}[]
}

type ReportFilter = {name: string, id: ReportFilterIdType} & (ReportFilterDateRange | ReportFilterSelectType | ReportFilterMultiSelectType | ReportFilterYesno)

type ReportOutput = {}
type ReportType = {
	description: string,
	filters: ReportFilter[],
	id: string|number,
	outputs: ReportOutput[],
	pdf: boolean,
	title: string
}

type PropsCJS = {reportTypes: ReportType[], ajaxPage: string}
export const run: CallJs<PropsCJS> = (cb, props) => {
	const div = document.createElement('div')
	const cc = new CommandCaller(props.ajaxPage)

	ReactDOM.render(<Reports {...props} commands={cc} />, div)

	cb(div)
}

type State = {
	reports: CustomReport[],
	newReportInfo: undefined|{info: NewReportInfo}
	submitting: boolean,
	loadedReport: undefined| CustomReport
}
type Props = {reportTypes: ReportType[], ajaxPage: string, commands: CommandCaller}

// T is some abstract type. maybe this is needlessly specific
type ReportResult<T> = {columns: ReportColumn<T>[], data: ReportData<T>[]}
type ReportColumn<T> = { headerText: string, dataField: keyof T, type: ColumnType }
type ReportData<T> = {[Z in keyof T]: string}

type ColumnType = 'text' | 'number' | 'numeric' /*a stringy type*/

type CustomReport = {
	authorId: string|number,
	authorName: string,
	description: string,
	filters: ReportFilter[]|null,
	instanceName: string,
	output: "0",
	reportId: string|number,
	reportSerial: string|number,
	reportType: string,
	title: string
}

const headingSingle = {'click': '',"reportSerial": "#", "title": "Report Name", description: "Description", reportType: "Report Type", authorName: "Author"}
class SingleTable extends FixedDataGrid<typeof headingSingle> {}

const toDateFrom = (id: SpecificPeriodType): Date => {
	const today = new Date()
	switch (id) {
		case 'thisYear':
			today.setFullYear(today.getFullYear() + 1)
			today.setMonth(0)
			today.setDate(0)
			today.setHours(0, 0, 0, 0)
			return today
		case 'thisMonth':
			today.setMonth(today.getMonth()+1)
			today.setDate(0)
			today.setHours(0, 0, 0, 0)
			return today
		case 'today':
			today.setDate(today.getDate() + 1)
			today.setHours(0, 0, 0, 0)
			return today
		case 'lastYear':
			today.setMonth(0)
			today.setDate(0)
			today.setHours(0, 0, 0, 0)
			return today
		case 'lastMonth':
			today.setDate(0)
			today.setHours(0, 0, 0, 0)
			return today
		case 'yesterday':
			today.setHours(0, 0, 0, 0)
			return today
	}
}
const labelFrom = (id: SpecificPeriodType): string => {
	switch (id) {
		case 'thisYear':
			return 'This Year';
		case 'thisMonth':
			return 'This Month';
		case 'today':
			return 'Today';

		case 'lastYear':
			return 'Last Year';
		case 'lastMonth':
			return 'Last Month';
		case 'yesterday':
			return 'Yesterday'
	}
}
const fromDateFrom = (id: SpecificPeriodType): Date => {
	const today = new Date()
	switch (id) {
		case 'thisYear':
			today.setMonth(0)
			today.setDate(1)
			today.setHours(0, 0, 0, 0)
			return today
		case 'thisMonth':
			today.setDate(1)
			today.setHours(0, 0, 0, 0)
			return today
		case 'today':
			today.setHours(0, 0, 0, 0)
			return today

		case 'lastYear':
			today.setFullYear(today.getFullYear() - 1)
			today.setMonth(0)
			today.setDate(1)
			today.setHours(0, 0, 0, 0)
			return today
		case 'lastMonth':
			today.setMonth(today.getMonth() - 1)
			today.setDate(1)
			today.setHours(0, 0, 0, 0)
			return today
		case 'yesterday':
			today.setDate(today.getDate() - 1)
			today.setHours(0, 0, 0, 0)
			return today
	}
}

const newFromId = (id: SpecificPeriodType): ReportFilterDateRange => {
	const fromDate = fromDateFrom(id)
	const toDate = toDateFrom(id)
	return ({
		filterType: FilterType.DateRange,
		selectedFilterItems: [{fromDate: dateToYYYYMMDD(fromDate), toDate: dateToYYYYMMDD(toDate), id, label: labelFrom(id)}]

	})
}

class Reports extends React.Component<Props, State> {
	constructor() {super();
		this.state = {reports: [], loadedReport: undefined, newReportInfo: undefined, submitting: false}
	}
	componentDidMount(): void {
		this.getReports().then(this.loadFromHash)
		window.addEventListener('hashchange', this.onHashChanged)
	}

	componentWillUpdate(nextProps: Readonly<Props>, nextState: Readonly<State>, nextContext: any): void {
		const old = this.state.loadedReport
		const new_ = nextState.loadedReport
		if(old == undefined && new_ !== undefined || (old !== undefined && new_ !== undefined && old.reportSerial !== new_.reportSerial) ) {
			window.location.hash = "#r=" + new_.reportSerial
		} else if (old !== undefined && new_ === undefined) {
			window.location.hash = "#"
		}
	}

	loadFromHash = (reports?: CustomReport[]) => {
		const hash = window.location.hash
		const parts = hash.split('=')
		if(parts.length == 2 && parts[0] == '#r') {
			this.loadReport(parts[1], reports)()
		} else {
			this.setState({loadedReport: undefined})
		}
	}

	//since this is a callback, we have an event to discard
	onHashChanged = () => {this.loadFromHash()}

	getReports = async () => {
		const reports = await this.props.commands.runGet('get custom reports') as CustomReport[]
		this.setState({reports})
		return reports
	}

	loadReport = (repId: string|number, reports?: CustomReport[]) => () => {
		const report = this.state.reports.find(r => r.reportSerial == repId) || reports && reports.find(r => r.reportSerial == repId)
		if(report) {
			this.setState({loadedReport: report})
		} else {
			this.setState({loadedReport: undefined})
		}
	}

	openNewReport = () => {this.setState({newReportInfo: {info: {reportType: this.props.reportTypes[0].id.toString(), title: "", description: ""}}})}
	cancelNewReport = () => {this.setState({newReportInfo: undefined})}
	saveReportStateless = async (report: Partial<CustomReport>): Promise<CustomReport> => {
		return await (this.props.commands.runPost('save report', report)) as Promise<CustomReport>
	}
	submitNewReport = async () => {
		const st = this.state.newReportInfo
		if(st) {
			this.setState({submitting: true})
			const params: Partial<CustomReport> = {
				description: st.info.description,
				reportId: st.info.reportType,
				title: st.info.title
			}
			await this.saveReportStateless(params)
			this.getReports()
			this.setState({submitting: false, newReportInfo: undefined})
		}
	}

	saveUpdateReport = async (report: CustomReport) => {
		this.setState({submitting: true})
		const newReport = await this.saveReportStateless(report)
		const reports = this.state.reports.map(r => r.reportSerial == newReport.reportSerial ? newReport : r)
		this.setState({reports, loadedReport: undefined, submitting: false}) // go via a render without the report loaded
		this.setState({loadedReport: newReport })
	}

	closeReport = () => {
		this.setState({loadedReport: undefined})
	}

	render() {
		const loadedReport = this.state.loadedReport
		if (loadedReport) {
			const reportType = this.props.reportTypes.find(r => r.id == loadedReport.reportId)
			if(!reportType) {
				return <div>The report you have tried to load is corrupt. <button onClick={this.closeReport}>Go back</button></div>
			} else {
				const filters = mergeReportFilters(loadedReport.filters, reportType.filters)
				const reportWithDefaultFilters = {...loadedReport, defualtFilters: filters}
				return <RenderReport
					commands={this.props.commands}
					saveReport={this.saveUpdateReport}
					submitting={this.state.submitting}
					closeReport={this.closeReport}
					report={reportWithDefaultFilters}
					reportType={reportType}
				/>
			}
		} else {
			return <RenderFrontPage
				reportTypes={this.props.reportTypes}
				submitting={this.state.submitting}
				newReportInfo={this.state.newReportInfo}
				reports={this.state.reports}
				loadReport={this.loadReport}
				onNewInfo={i => this.setState(s=>({newReportInfo: {info: {...(s.newReportInfo||{info: undefined}).info , ...i}, submitting: false}}))}
				submitNewReport={this.submitNewReport}
				cancelNewReport={this.cancelNewReport}
				openNewReport={this.openNewReport}
				/>
		}
	}
}

const mergeReportFilters = (chosen: ReportFilter[]|null, defaults: ReportFilter[]): ReportFilter[] => {
	//the filter we want to use consists of the setting from the one,
	//but everything else from the old one.
	const merge = (def: ReportFilter): ReportFilter => {
		const it = chosen && chosen.find(c => c.id == def.id)
		return it && it.filterType == def.filterType ? {...def, selectedFilterItems: it.selectedFilterItems} as ReportFilter : def
	}
	return chosen ? defaults.map(merge)  : defaults
}

type EditFilterModalProps<T> = {
	defaultValue: ReportFilter & T
	onChange: (v: ReportFilter&T) => void
	onClose: () => void
}

type SpecificPeriodType = "thisYear"|"yesterday"|"thisMonth"|"lastYear"|"lastMonth"|"today"

type EditSelectFilterModalState = { value: string|undefined }
type EditMultiSelectFilterModalState = { values: string[], something: boolean }

type EditDateRangeFilterModalState = {
	specificPeriod: SpecificPeriodType
	value: ReportFilterDateRangeType
	fromDate: Date
	toDate: Date
	fromMonthYear: [number, number]
	toMonthYear: [number, number]
}

const isSpecificPeriod  = (t: ReportFilterDateRangeType): t is SpecificPeriodType => {
	switch (t) {
		case "thisYear":
		case "yesterday":
		case "thisMonth":
		case "lastYear":
		case "lastMonth":
		case "today":
			return true
		case "dateRange":
		case "monthYearRange":
			return false
	}
}

const EditFilterModal = (props: EditFilterModalProps<ReportFilter>) => {
	const value = props.defaultValue
	switch (value.filterType) {
		case FilterType.YesNo:
			return <EditFilterYesnoModal {...props} defaultValue={value}/>
		case FilterType.DateRange:
			return <EditFilterDateRangeModal {...props} defaultValue={value} />
		case FilterType.Select:
			return <EditFilterSelectModal{...props} defaultValue={value} />
		case FilterType.MultiSelect:
			return <EditFilterMultiSelectModal {...props} defaultValue={value} />
	}
}

type EditYesnoFilterModalState = {selected: boolean}

class EditFilterYesnoModal extends React.Component<EditFilterModalProps<ReportFilterYesno>, EditYesnoFilterModalState> {
	constructor(props: EditFilterModalProps<ReportFilterYesno>) {
		super();
		const v = props.defaultValue.selectedFilterItems[0]
		this.state = {selected: v ? v.selected : false}
	}

	private onSubmit = () => {
		this.props.onChange({...this.props.defaultValue, selectedFilterItems: [{selected: this.state.selected}]})
	}

	change = (i: string) => {this.setState({selected: i == "Yes"})}

	cssProps = centeredModalProps('600px')

	render() {
		return <Modal style={this.cssProps} isOpen={true} title={`Edit ${this.props.defaultValue.name} Filter`} onRequestClose={this.props.onClose}>
			<Form onSubmit={this.onSubmit}>
				<Item label={this.props.defaultValue.name}>
					<SingleBox onChange={this.change} value={this.state.selected ? "Yes" : "No"}>
						<option value="No">No</option>
						<option value="Yes">Yes</option>
					</SingleBox>
				</Item>

			</Form>
		</Modal>
	}
}

class EditFilterSelectModal extends React.Component<EditFilterModalProps<ReportFilterSelectType>, EditSelectFilterModalState> {
	constructor(props: EditFilterModalProps<ReportFilterSelectType>) {
		super();
		this.state = {value: props.defaultValue.selectedFilterItems.reduce((a, b) => b.id, '')}
	}

	private onSubmit = () => {
		const i = this.props.defaultValue.filterItems.find(i => this.state.value == i.id)
		const selectedFilterItems = i ? [i] : []
		this.props.onChange({...this.props.defaultValue, selectedFilterItems})
	}

	change = (i: string) => {this.setState({value: i})}

	cssProps = centeredModalProps('600px')

	render() {

		return <Modal style={this.cssProps} isOpen={true} title={`Edit ${this.props.defaultValue.name} Filter`} onRequestClose={this.props.onClose}>
			<Form onSubmit={this.onSubmit}>
				<Item label={this.props.defaultValue.name}>
					<SingleBox onChange={this.change} value={this.state.value}>
						<option value="">All</option>
						{this.props.defaultValue.filterItems.map(i => <option key={i.id} value={i.id}>{i.label}</option>)}
					</SingleBox>
				</Item>

			</Form>
		</Modal>
	}
}

class EditFilterMultiSelectModal extends React.Component<EditFilterModalProps<ReportFilterMultiSelectType>, EditMultiSelectFilterModalState> {
	constructor(props: EditFilterModalProps<ReportFilterSelectType>) {
		super();
		this.state = {
			values: props.defaultValue.selectedFilterItems.map(b => b.id),
			something: props.defaultValue.selectedFilterItems.length > 0
		}
	}

	private onSubmit = () => {
		const selectedFilterItems = this.state.something ? this.props.defaultValue.filterItems.filter(i => this.state.values.find(v => v == i.childValue))
			.map(i => ({id: i.childValue, label: i.childName})) : []
		if(selectedFilterItems.length == 0 && this.state.something) {
			alert(`Please select some ${this.props.defaultValue.name} or choose "All".`)
		} else {
			this.props.onChange({...this.props.defaultValue, selectedFilterItems})
		}
	}

	change = (i: string, checked: boolean) => () => {
		this.setState(s => ({values: checked ? [...s.values, i] : s.values.filter(v => v != i)}) )
	}

	deselectAll = () => {this.setState({something: false})}
	selectSomething = () => {this.setState({something: true})}

	cssProps = {width: "600px"}

	render() {
		return <Modal style={this.cssProps} isOpen={true} title={`Edit ${this.props.defaultValue.name} Filter`} onRequestClose={this.props.onClose}>
			<Form onSubmit={this.onSubmit}>
				<Item label={this.props.defaultValue.name}>
					<ul className="sbCheckboxGroup">
						<li className="sbCheckboxItem sbCheckboxGroupVertical">
					<Radio onChange={this.deselectAll} checked={!this.state.something} name="whichones" label={`All ${this.props.defaultValue.name}`}/>
						</li> <li className="sbCheckboxItem sbCheckboxGroupVertical">
					<Radio onChange={this.selectSomething} checked={this.state.something} name="whichones" label={`Specific ${this.props.defaultValue.name}`}/>
					{this.state.something &&
					<fieldset>
						<ul className="sbCheckboxGroup">
						{this.props.defaultValue.filterItems.map(i => {
							const checked = !!this.state.values.find(v => v == i.childValue)
							return <li key={i.childValue} className="sbCheckboxItem sbCheckboxGroupVertical"><Checkbox
								key={i.childValue}
								label={i.childName}
								checked={checked}
								onChange={this.change(i.childValue, !checked)}
							/></li>
						})}
						</ul>
					</fieldset>}
					</li>
					</ul>
				</Item>

			</Form>
		</Modal>
	}
}

class EditFilterDateRangeModal extends React.Component<EditFilterModalProps<ReportFilterDateRange>, EditDateRangeFilterModalState> {
	constructor(props: EditFilterModalProps<ReportFilterDateRange>) {
		super(props);

		const val = this.props.defaultValue.selectedFilterItems[0]
		const value = val?val.id:'thisYear'
		const fromDate = new Date(val ? val.fromDate: "1 January")
		const toDate = new Date(val ? val.toDate : "31 December")

		this.state = {
			specificPeriod: isSpecificPeriod(value) ? value : 'thisYear',
			fromDate,
			toDate,
			fromMonthYear: [fromDate.getMonth() + 1, fromDate.getFullYear()],
			toMonthYear: [toDate.getMonth() + 1, toDate.getFullYear()],
			value
		}
	}

	onSpecificPeriod = () => {
		this.onChange(this.state.specificPeriod)
	}

	onChange = (value: ReportFilterDateRangeType) => {
		this.setState(s => ({
			specificPeriod: isSpecificPeriod(value) ? value : s.specificPeriod,
			value: value
		}))
	}

	onSubmit = () => {
		const value = this.state.value
		switch (value) {
			case "dateRange":
				//typescript gets super confused unless i do this sideeffectively.
				const a: ReportFilter & ReportFilterDateRange = {...this.props.defaultValue}
				a.filterType = FilterType.DateRange
				a.selectedFilterItems =  [{
					id: value,
					label: `${this.state.fromDate.toLocaleDateString('en-AU')} - ${this.state.toDate.toLocaleDateString('en-AU')}` ,
					fromDate: dateToYYYYMMDD(this.state.fromDate),
					toDate: dateToYYYYMMDD(this.state.toDate),
				}]
				const c: (n: ReportFilter&ReportFilterDateRange) => void = this.props.onChange
				c(a)
				return;
			case "monthYearRange":
				const fromDate = new Date()
				fromDate.setFullYear(this.state.fromMonthYear[1])
				fromDate.setMonth(this.state.fromMonthYear[0]-1)
				fromDate.setDate(1)
				fromDate.setHours(0, 0, 0, 0)

				const toDate = new Date()
				toDate.setFullYear(this.state.toMonthYear[1])
				toDate.setMonth(this.state.toMonthYear[0]) //yes, the zeroth of next month
				toDate.setDate(0)
				toDate.setHours(23, 59, 59, 999)

				const fromMon = monthToUserString(numberToMaybeMonth(this.state.fromMonthYear[0]))
				const toMon = monthToUserString(numberToMaybeMonth(this.state.toMonthYear[0]))

				//typescript gets confused unless i do this sideeffectly.
				const b = {...this.props.defaultValue}
				b.selectedFilterItems=  [{
					id: value,
					label: `${fromMon} ${this.state.fromMonthYear[1]} - ${toMon} ${this.state.toMonthYear[1]}`,
					fromDate: dateToYYYYMMDD(fromDate),
					toDate: dateToYYYYMMDD(toDate),
				}]

				this.props.onChange(b)
				return;
			case "thisYear":
			case "thisMonth":
			case "today":
			case "lastYear":
			case "lastMonth":
			case "yesterday":
				const d = {...this.props.defaultValue, ...newFromId(value)}
				this.props.onChange(d)
				return;
		}
		// noinspection JSUnusedLocalSymbols
		const v: never = value
	}

	onStandard = (value: ReportFilterDateRangeType) => {
		this.setState({value})
	}

	setFromYear = (d: string) => {
		this.setState({fromMonthYear: [this.state.fromMonthYear[0], Number.parseInt(d)]})
	}

	setToYear = (d: string) => {
		this.setState({toMonthYear: [this.state.toMonthYear[0], Number.parseInt(d)]})
	}

	setToMonth = (d: string) => {
		this.setState({toMonthYear: [Number.parseInt(d), this.state.toMonthYear[1]]})
	}

	setFromMonth = (d: string) => {
		this.setState({fromMonthYear: [Number.parseInt(d), this.state.fromMonthYear[1]]})
	}

	setFromDate = (_: string, fromDate: Date) => {this.setState({fromDate})}
	setToDate = (_: string, toDate: Date) => {this.setState({toDate})}

	render() {
		const name = "edit-filter-name-thingo"
		const specificPeriodName = "edit-filter-specific-period-name-thingo"
		const SpecificPeriodRadio = (p: {value: SpecificPeriodType}) => <p>
			<Radio label={labelFrom(p.value)} name={specificPeriodName} checked={this.state.specificPeriod==p.value} onChange={()=>this.onChange(p.value)}/>
		</p>

		const isMonthYearRange=this.state.value == "monthYearRange"
		const isDateRange = this.state.value == "dateRange"

		const specificPeriod = isSpecificPeriod(this.state.value)
		return <Modal style={{width: "700px"}} isOpen={true} title="Edit Filter" onRequestClose={this.props.onClose}>
		<Form onSubmit={this.onSubmit}>
		<Item label="Specific Period">
		<Radio label="Specific Period" name={name} checked={specificPeriod} onChange={this.onSpecificPeriod} />
		<fieldset disabled={!specificPeriod} style={{marginLeft: "2em"}}>
		<div style={{float:"left", width: "50%"}}>
		<SpecificPeriodRadio value="thisYear"/>
		<SpecificPeriodRadio value="thisMonth"/>
		<SpecificPeriodRadio value="today"/>
			</div>
			<div style={{float:"right", width: "50%"}}>
		<SpecificPeriodRadio value="lastYear"/>
		<SpecificPeriodRadio value="lastMonth"/>
		<SpecificPeriodRadio value="yesterday"/>
			</div>
			</fieldset>
			</Item>
			<Item label="Date Range">
		<Radio label="Date Range" name={name} checked={isDateRange} onChange={() => this.onStandard('dateRange')} />
		<fieldset disabled={!isDateRange} style={{marginLeft: "2em"}}>
		<Item label="From">
		<DatePicker date={this.state.fromDate} onChange={this.setFromDate} readonly={!isDateRange} invalid={false} />
		</Item>
		<Item label="To">
		<DatePicker date={this.state.toDate} onChange={this.setToDate} readonly={!isDateRange} invalid={false} />
		</Item>
		</fieldset>
		</Item>

		<Item label="Month Year Range">
		<Radio label="Month Year Range" name={name} checked={isMonthYearRange} onChange={() => this.onStandard('monthYearRange')} />
		<fieldset disabled={!isMonthYearRange} style={{marginLeft: "2em"}}>
		<Item label="From">
		<SingleBox onChange={this.setFromMonth} value={this.state.fromMonthYear[0].toString()} >
		<option value="1">January</option>
			<option value="2">February</option>
			<option value="3">March</option>
			<option value="4">April</option>
			<option value="5">May</option>
			<option value="6">June</option>
			<option value="7">July</option>
			<option value="8">August</option>
			<option value="9">September</option>
			<option value="10">October</option>
			<option value="11">November</option>
			<option value="12">December</option>
			</SingleBox>
			<Input onChange={this.setFromYear} value={this.state.fromMonthYear[1].toString()} numeric={{min: 1950}} />
		</Item>
		<Item label="To">
		<SingleBox onChange={this.setToMonth} value={this.state.toMonthYear[0].toString()} >
		<option value="1">January</option>
			<option value="2">February</option>
			<option value="3">March</option>
			<option value="4">April</option>
			<option value="5">May</option>
			<option value="6">June</option>
			<option value="7">July</option>
			<option value="8">August</option>
			<option value="9">September</option>
			<option value="10">October</option>
			<option value="11">November</option>
			<option value="12">December</option>
			</SingleBox>
			<Input onChange={this.setToYear} value={this.state.toMonthYear[1].toString()} numeric={{min: 1950}} />
		</Item>
		</fieldset>
		</Item>
		</Form>
		</Modal>
	}
}

type CustomReportWithDefaultFilters = {
	authorId: string|number,
	authorName: string,
	description: string,
	defualtFilters: ReportFilter[],
	instanceName: string,
	output: "0",
	reportId: string|number,
	reportSerial: string|number,
	reportType: string,
	title: string
}

type RenderReportProps = {
	closeReport: () => void,
	report: CustomReportWithDefaultFilters
	reportType: ReportType
	commands: CommandCaller
	submitting: boolean,
	saveReport: (report: CustomReport) => Promise<void>
}

type RenderReportState = {
	running: boolean
	results: undefined|ReportResult<any>,

	updatingReportProps: undefined|{description: string, title: string}
	showFilterModal: undefined|number,

	filters: ReportFilter[]
}

class RenderReport extends React.Component<RenderReportProps, RenderReportState> {
	constructor(props:RenderReportProps) {super(props);
		this.state = RenderReport.getBlankState(props.report)
	}

	componentDidUpdate(prevProps: Readonly<RenderReportProps>, prevState: Readonly<RenderReportState>, prevContext: any): void {
		if(this.props.report.reportSerial != prevProps.report.reportSerial) {
			this.initialize(this.props)
		}
	}

	componentWillMount(): void {this.initialize(this.props)}

	closeFilter = () => {
		this.setState({showFilterModal: undefined})
	}

	cancelSaveReport = () => {
		this.setState({updatingReportProps: undefined})
	}

	openFilter = (id: number) => {
		if(this.state.filters[id] !== undefined) {
			this.setState({showFilterModal: id})
		}
	}

	openSaveReportModal = () => {
		const report = this.props.report
		this.setState({
				updatingReportProps: {
					description: report.description,
					title: report.title,
				}
			}
		)
	}

	saveCsv = () => {
		const results = this.state.results
		if(!results) return
		const fields = results.columns.map(m => m.dataField)
		const header = [results.columns.map(m => m.headerText)]
		const dataRows = results.data.map(m => fields.map(f => m[f]))
		const rows = header.concat(dataRows)
		const csvContent = "data:text/csv;charset=utf-8,";
		const out = csvContent + rows.map(r => r.join(',')).join("\n")
		const a = document.createElement('a')
		a.setAttribute('href', encodeURI(out))
		a.setAttribute('download', this.props.report.title + ".csv")
		document.body.appendChild(a)
		a.click()
		document.body.removeChild(a)
	}

	onNewInfo = (n: NewReportInfo|SaveReportInfo) => {
		this.setState({updatingReportProps: n})
	}

	setFilter = (id: number, v: ReportFilter) => {
		const filters = this.state.filters
		if(filters[id] !== undefined) {
			const new_filters = [...filters]
			new_filters[id] = v
			this.setState( {filters: new_filters})
			const rep ={...this.props.report, filters: new_filters} //hack around typescripts extraordinary and misplaced punctiliousness with a redundant const
			this.runReportWithReport(rep)
		}
	}

	submitSaveReport = async() => {
		const updatingProps = this.state.updatingReportProps
		if(!updatingProps) return
		const oldReport = {...this.props.report, title: updatingProps.title, description: updatingProps.description, filters: this.state.filters}
		await this.props.saveReport(oldReport)
		this.setState({updatingReportProps: undefined})
	}

	static getBlankState = (rep: CustomReportWithDefaultFilters): RenderReportState => {
		return {
			running: false,
			results: undefined,
			showFilterModal: undefined,
			updatingReportProps: undefined,
			filters: rep.defualtFilters
		}
	}

	private initialize = (props: RenderReportProps) => {
		//i want to ensure we blank out the state here.
		this.setState(RenderReport.getBlankState(props.report))
		this.runReport()
	}

	runReport = async () => {
		const r = {...this.props.report, filters: this.state.filters} //i haven't literally written the prohibited props name, it just comes for the ride
		await this.runReportWithReport(r)
	}

	runReportWithReport = async (report: CustomReport) => {
		this.setState(({running: true}))
		try {
			const res = await this.props.commands.runGet('run report', {
				id: report.reportId,
				filters: report.filters && report.filters.map(m => ({...m, filterItems: undefined}))
			}) as [ReportResult<any>]
			this.setState(({results: res[0], running: false}))
		} catch (e) {
			this.setState(({running: false}))
		}
	}

	render() {
		const props = this.props
		const showingFilterModal = this.state.showFilterModal
		const modal = showingFilterModal !== undefined &&
			<EditFilterModal
				defaultValue={this.state.filters[showingFilterModal]}
				onChange={(v) => {
					this.setFilter(showingFilterModal, v);
					this.closeFilter()
				}}
				onClose={this.closeFilter}
			/>
		const saveReportModal = this.state.updatingReportProps && <NewReportModal
			type="save"
			reportType={this.props.reportType.title}
			info={this.state.updatingReportProps}
			submitting={this.props.submitting}
			onNewInfo={this.onNewInfo}
			onSave={this.submitSaveReport}
			onRequestClose={this.cancelSaveReport} />
		return <div>
			{modal}{saveReportModal}
			<h1>{props.report.title} · {props.reportType.title}</h1>
			<p>{props.report.description}</p>
			<Toolbar>
				<Button onClick={props.closeReport} icon="/sb/static/images/icons/arrow_left.png">Back</Button>
				<Button onClick={this.openSaveReportModal} emoji="💾">Save</Button>
				<Button disabled={this.state.running} onClick={this.runReport} emoji="🏃">Run</Button>
				{this.state.results && <Button onClick={this.saveCsv} emoji="📈">Export Spreadsheet</Button>}
				{(this.props.submitting || this.state.running) &&
				<img className="loadingImage" src="/sb/static/images/loadergif.gif" />}
			</Toolbar>
			<div style={{position: "relative"}}>
				<div style={{
					position: "absolute",
					paddingRight: "10px",
					borderRight: "1px solid black",
					width: "20%"
				}}>
					{this.state.filters.map((r, n) =>
						<RenderFilter key={n} openFilter={() => this.openFilter(n)} r={r}/>)}
				</div>
				<div style={{
					position: "absolute",
					paddingLeft: "10px",
					marginLeft: "10px",
					borderLeft: "1px solid black",
					left: "20%",
					width: "80%"
				}}>{this.state.results && <RenderResults results={this.state.results} />}</div>
			</div>
		</div>
	}
}

const makeLabel = (r: ReportFilter): string => {
	switch (r.filterType) {
		case FilterType.YesNo:
			const k = r.selectedFilterItems[0]
			return k ? (k.selected ? 'Yes': 'No') : 'Default'
		case FilterType.DateRange:
			const i = r.selectedFilterItems[0]
			return i?i.label:"Unspecified, unclear time period"
		case FilterType.Select:
		case FilterType.MultiSelect:
			const l = r.selectedFilterItems.map(i => i.label).join(", ")
			return l || "All"

	}
}

const RenderFilter = (props: {r: ReportFilter, openFilter: () => void}) => {
	const r = props.r
	const label = makeLabel(props.r)

	return <div key={r.id} onClick={props.openFilter} style={{
		border: "1px solid rgb(0, 169, 224)",
		cursor: "pointer",
		position: "relative"
	}}>
		<p style={{margin: "0px", fontWeight: "bold"}}>{r.name}</p>
		<p>{label}</p>
		<button style={{
			position: "absolute",
			top: "0px",
			right: "0px",
			margin: "5px",
			fontSize: "200%",
			color: "#00a9e0",
			padding: "0px",
			border: "0px none",
			backgroundColor: "transparent"
		}}>⚙️</button>
	</div>
}

const money: NumberFormatOptions = {minimumFractionDigits: 2}

const RenderResults = <T extends {}>(props: {results: ReportResult<T>}) => {
	const heading = props.results.columns.reduce((old, cur) =>
		({
			...old,
			[cur.dataField]: cur.headerText
		}), {})

	const typeMap: {[K in keyof T]: ColumnType} = props.results.columns.reduce((old, cur) =>
		({...(old as {}), [cur.dataField]: cur.type} as {[K in keyof T]: ColumnType}), {} as {[K in keyof T]: ColumnType}
	)

	const formatColumn = (a: ReportData<T>, cur: keyof T): Data => {
		const type: ColumnType = typeMap[cur]
		switch (type) {
			case "number":
				const num = Number.parseFloat(a[cur])
					return {
					alignment: 'right',
					node: isNaN(num) ? a[cur] : num.toLocaleString('en-AU', money)
				}
			case "numeric": return {
				alignment: 'right',
				node: a[cur]
			}
			case "text": return {
				node: a[cur]
			}
		}
		throw `oh noes, i know nothing of ${type} for column ${cur}`
	}

	const headingAlignments = props.results.columns.reduce((old, cur) =>
		({...old, [cur.dataField]: toHeadingAlignment(cur.type)}), {})

	const toDatagridRow = (a: ReportData<T>) => props.results.columns.map(k => k.dataField).reduce((old, cur) => {
		return ({...old, [cur]: formatColumn(a, cur)})
	}, {})
	const data = props.results.data.map(toDatagridRow)
	return <div>
		<FixedDataGrid headingAlignments={headingAlignments} heading={heading} data={data}/>
		<div style={{width: "100%", textAlign: "right"}}>
		</div>
	</div>
}

const toHeadingAlignment = (v: ColumnType): 'center'|'right'|'left' => {
	switch (v) {
		case "number": return "right"
		case "numeric": return "right"
		case "text": return "center"
	}
}

type RenderFrontPageProps = {
	reports: CustomReport[]
	newReportInfo?: {info: NewReportInfo}
	submitting: boolean
	loadReport: (id: string|number) => () => void
	reportTypes: ReportType[]
	onNewInfo: (info: NewReportInfo|SaveReportInfo) => void
	submitNewReport: () => void
	cancelNewReport: () => void
	openNewReport: () => void
}

const RenderFrontPage = (props: RenderFrontPageProps) => {
	const v: Row<keyof typeof headingSingle>[] = props.reports.map(r => ({
		click: props.loadReport(r.reportSerial),
		reportSerial: {node: r.reportSerial, alignment: Alignment.left},
		title: {node: r.title, alignment: Alignment.left},
		description: {node: r.description, alignment: Alignment.left},
		reportType: {node: r.reportType, alignment: Alignment.left},
		authorName: {node: r.authorName, alignment: Alignment.left}}))
	const newReportInfo = props.newReportInfo
	const modal = newReportInfo &&
		<NewReportModal
			type="new"
			reportTypes={props.reportTypes.map(r => ({value: r.id.toString(), label: r.title}))}
			info={newReportInfo.info}
			submitting={props.submitting}
			onNewInfo={props.onNewInfo}
			onSave={props.submitNewReport}
			onRequestClose={props.cancelNewReport} />

	return <div>{modal}
		<h1>Reports</h1>
		<Toolbar><Button onClick={props.openNewReport} icon="/sb/static/images/icons/addIcon.png"/></Toolbar>
		<SingleTable rowClick='click' widths="leave undefined" heading={headingSingle} data={v} />
	</div>
}

const Toolbar = (props: {children: (JSX.Element|boolean|undefined)[]|JSX.Element}) => {return <div>{props.children}</div>}

type NewReportInfo = {reportType: string, title: string, description: string}
type SaveReportInfo = {title: string, description: string}
type NewReportProps = {
	onRequestClose: () => void,
	submitting: boolean
	onSave: () => void
	onNewInfo: (info: NewReportInfo|SaveReportInfo) => void //sigh, oh typescript
} & ({
	type: 'new'
	reportTypes: {value: string, label: string}[]
	info: NewReportInfo
}|{
	type: 'save'
	info: SaveReportInfo
	reportType: string
})
const NewReportModal = (props: NewReportProps) => {
	const cssProps = centeredModalProps('600px')
	cssProps.overflow = undefined
	const reportType =
		<Item label="Report Type">
			{props.type == 'new' ?
			<SingleBox enabled={!props.submitting} onChange={v => props.onNewInfo({...props.info, reportType: v})} value={props.info.reportType}>
				{props.reportTypes.map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
			</SingleBox>
			: props.reportType
			}
		</Item>

	return <Modal style={cssProps} isOpen={true} title={props.type == 'new' ? "New Report" : "Save Report"} onRequestClose={props.onRequestClose}>
	<Form isSubmitting={props.submitting} hasCancel={true} onCancel={props.onRequestClose} onSubmit={props.onSave}>
	{reportType}
	<Item label="Title">
		<Input disabled={props.submitting} value={props.info.title} onChange={v => props.onNewInfo({...props.info, title: v})} />
	</Item>
	<Item label="Description">
		<Textarea disabled={props.submitting} value={props.info.description} onChange={v => props.onNewInfo({...props.info, description: v})} />
	</Item>
	</Form>
	</Modal>
}



// WEBPACK FOOTER //
// ./src/orders2/reports/index.tsx